import React, { useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { useCallApi } from '../../hooks/CallApi';
import useFetchReceptionData from '../../hooks/FetchReceptionData';
import PreExaminationDetail from './PreExaminationDetail';
import ReceptionDetail from './ReceptionDetail';
import PreliminaryExaminationResultInput from './PreliminaryExaminationResultInput';

const App: React.FC = () => {
  // ローディング画面制御
  const [is_loading, setIsLoading] = useState(true);

  const {
    // ヘッダ
    label,
    guide_text,
    step_navigation,
    display_reception_cd,
    display_status,
    // 詳細画面情報
    parent_shelfs,
    child_shelfs,
    contents,
    // 固定パラメータ
    status_name,
    status_code,
    loan_type,
    reception_id,
    reception_cd,
    reception_sub_cd,
    ident_lv1_cd,
    ident_lv2_cd,
    ident_lv3_cd,
    ja_name,
    opened_mypage,
    is_staff,
    applied,
    is_change,
    has_debtor,
    is_disagree,
    change_request_message,
    guarantors_num,
    sign_info,
    agreements,
    is_sent_to_guaranty_company,
    is_csv_downloaded,
    office_list,
    management_store_cd,
    review_approval_status_name,
    review_message,
    guarantee_agency_examination_result_name,
    consent_datetime_privacy,
    consent_datetime_not_antisocial_forces,
    suspicious_irregularity_flg,
    guarantor_info,
    has_hosho_flg,
    // ファイルアップローダ
    shelf_info_a,
    shelf_info_b,
    shelf_info_c,
    shelf_info_d,
    shelf_info_e,
    shelf_info_f,
    shelf_info_g,
    shelf_info_h,
    shelf_info_i,
    // ディスパッチ
    setParentShelfs,
    setChildShelfs,
    setContents,
    setShelfInfoA,
    setShelfInfoB,
    setShelfInfoC,
    setShelfInfoD,
    setShelfInfoE,
    setShelfInfoF,
    setShelfInfoG,
    setShelfInfoH,
    setShelfInfoI,
    // 関数
    moveStepNav,
    setManagementStoreCd,
    setOnlineIdentificationModalOpen,
  } = useFetchReceptionData(setIsLoading);

  // API呼び出し処理
  const { show_error_nav, api_response_detail, requestModule } = useCallApi(
    child_shelfs,
    contents,
    setContents,
    setChildShelfs,
    reception_id,
    reception_cd,
    status_code,
    is_staff,
    setIsLoading,
    guarantor_info,
    setOnlineIdentificationModalOpen
  );

  return (
    <Router>
      <Switch>
        {/* KWANKGM11010_事前審査案件詳細（職員） */}
        <Route exact path="/reception/:reception_cd/:reception_id/(1850|1950)">
          <PreExaminationDetail
            step_navigation={step_navigation}
            reception_cd={reception_cd}
            reception_id={reception_id}
            label={label}
            status_name={status_name}
            display_reception_cd={display_reception_cd}
            guide_text={
              guide_text !== null && guide_text[step_navigation.current]
                ? guide_text[step_navigation.current]
                : ''
            }
            looks_inactive={false} // 入力可否
            parent_shelfs={parent_shelfs}
            child_shelfs={child_shelfs}
            contents={contents}
            setParentShelfs={setParentShelfs}
            setChildShelfs={setChildShelfs}
            setContents={setContents}
            guarantors_num={guarantors_num}
            show_error_nav={show_error_nav}
            display_status={display_status}
            is_loading={is_loading}
            setIsLoading={setIsLoading}
            is_sent_to_guaranty_company={is_sent_to_guaranty_company}
            is_csv_downloaded={is_csv_downloaded}
            office_list={office_list}
            management_store_cd={management_store_cd}
            setManagementStoreCd={setManagementStoreCd}
            callApi={requestModule}
            guarantor_info={guarantor_info}
            guarantee_agency_examination_result_name={guarantee_agency_examination_result_name}
            consent_datetime_privacy={consent_datetime_privacy}
            consent_datetime_not_antisocial_forces={consent_datetime_not_antisocial_forces}
            is_staff={is_staff}
            suspicious_irregularity_flg={suspicious_irregularity_flg}
            has_hosho_flg={has_hosho_flg}
          />
        </Route>
        {/* KWANKGM11020_事前審査結果入力（承認・不承認）（職員） */}
        <Route exact path="/reception/:reception_cd/:reception_id/result_input">
          <PreliminaryExaminationResultInput
            reception_cd={reception_cd}
            reception_id={reception_id}
            is_loading={is_loading}
            setIsLoading={setIsLoading}
            status_code={status_code}
          />
        </Route>
        {/* KWANKGM10040_案件詳細（職員） */}
        <Route path="/reception/:reception_cd/:reception_id/:status_code">
          <ReceptionDetail
            step_navigation={step_navigation}
            reception_cd={reception_cd}
            reception_id={reception_id}
            label={label}
            status_name={status_name}
            display_reception_cd={display_reception_cd}
            guide_text={
              guide_text !== null && guide_text[step_navigation.current]
                ? guide_text[step_navigation.current]
                : ''
            }
            looks_inactive={false} // 入力可否
            parent_shelfs={parent_shelfs}
            child_shelfs={child_shelfs}
            contents={contents}
            setParentShelfs={setParentShelfs}
            setChildShelfs={setChildShelfs}
            setContents={setContents}
            guarantors_num={guarantors_num}
            show_error_nav={show_error_nav}
            display_status={display_status}
            is_loading={is_loading}
            callApi={requestModule}
            setIsLoading={setIsLoading}
            office_list={office_list}
            management_store_cd={management_store_cd}
            review_approval_status_name={review_approval_status_name}
            review_message={review_message}
            guarantee_agency_examination_result_name={guarantee_agency_examination_result_name}
            consent_datetime_privacy={consent_datetime_privacy}
            consent_datetime_not_antisocial_forces={consent_datetime_not_antisocial_forces}
            status_code={status_code}
            is_staff={is_staff}
            suspicious_irregularity_flg={suspicious_irregularity_flg}
            is_csv_downloaded={is_csv_downloaded}
            guarantor_info={guarantor_info}
          />
        </Route>
      </Switch>
    </Router>
  );
};
if (document.getElementById('template-staff')) {
  ReactDOM.render(<App />, document.getElementById('template-staff'));
}
